// Test tools → templates waiting for Meta: answer "approved" / "rejected" as Meta would (the real answer comes
// from the vendor's callback). Only for a role that may edit channels.
import { SimulateMetaButtons, useTemplates } from '@/features/whatsapp-templates'

export function PendingTemplates() {
  const templates = useTemplates('whatsapp')
  const pending = templates.data?.filter((t) => t.status === 'pending') ?? []
  if (!pending.length) return <p className="help">No template is waiting for Meta.</p>
  return (
    <ul className="space-y-1.5">
      {pending.map((template) => (
        <li key={template.id} className="flex flex-wrap items-center gap-1 text-xs">
          <span className="mono">{template.name}</span>
          <SimulateMetaButtons template={template} />
        </li>
      ))}
    </ul>
  )
}
